import { Images, Price } from '@spartacus/core';
import { CustomProduct } from './product.model';
import { CustomProductAddress, ShipToParty } from './addresses.model';
import { CartModification } from '@spartacus/cart/base/root';

export interface SavedCartData {
  savedCartData: CartsApi;
}

export interface AllCartsApi {
  carts: CartsApi[]
}

export interface CartUpdated {
  quantity: number;
  quantityAdded: number;
  statusCode: string;
  entry: CartItem
}

export interface CartsApi {
  childCarts: Cart[],
  code: string,
  entries: any[],
  guid: string,
  totalItems: number,
  totalPrice: Price,
  totalPriceWithTax: Price,
  type: string
  description?: string,
  modifiedTime?: string,
  name?: string,
  saveTime?: string,
  savedBy?: SavedBy,
  createdTime?: string
  removedEntries?: RemovedEntries;
}

export interface Cart {
  cartType: string,
  code: string,
  deliveryAddress: CustomProductAddress,
  entries: CartItem[],
  onsnEntriesCount: number,
  orderContact: OrderContact,
  shipToParty: ShipToParty,
  subTotal: Price,
  totalItems: number,
  totalPrice: Price,
  totalPriceWithTax: Price,
  totalTax: Price,
  lastOrdered?: string
  contractName?: string,
  contractId?: string
}

export interface CartItem {
  basePrice: Price,
  cancellableQuantity: number,
  configurationInfos: ConfigurationInfo,
  confirmedDate: string,
  entryNumber: number,
  freightProduct: boolean,
  product: CustomProduct,
  quantity: number,
  quantityStatus: string,
  returnableQuantity: number,
  sapEntryNumber: number,
  slob: boolean,
  statusSummaryList: any[],
  totalPrice: Price,
  unit: string
}

interface ConfigurationInfo {
  configurationLabel?: string;
  configurationValue?: string;
  configuratorType?: string;
  status?: string;
}

interface OrderContact {
  email: string,
  name: string
}

interface SavedBy {
  name: string,
  uid: string
}

interface RemovedEntries {
  cartModifications: CartModification[];
}

export interface CustomCartItemEntry extends CartItem {
  conditionsForCartonsLogicMeet?: boolean;
}

export type CartItemEntry = CustomCartItemEntry | Images;

export interface EntryUpdateParams {
  entryNumber: number;
  quantity: string;
}

export enum CartType {
  STANDARD = 'STANDARD',
  INFLUENZA = 'INFLUENZA'
}
